<template>
    <BModal :model-value="modal" scrollable centered title="Extra Charge Category" hide-footer @update:modelValue="updateModal">
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Extra Charge Category</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="updateModal(false)"
            >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <BForm>
            <div class="form-group">
                <BFormInput type="text" v-model="extrachargeCategoryForm.name" placeholder="Name"></BFormInput>
            </div>
        </BForm>
        
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" @click="handleAction" class="mr-2">{{ extrachargeCategoryData && extrachargeCategoryData.uuid ? 'Update' : 'Save'}}</BButton>
                <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
            </div>
        </template> 
    </BModal>
</template>

<script>
import { BModal, BFormInput,BButton, BForm } from 'bootstrap-vue-next';
import { ref, inject, watch } from 'vue';

export default {
    components: {
        BModal,
        BFormInput,
        BButton,
        BForm
    },
    props: {
        modal: Boolean,
        extrachargeCategoryData: Object,
    },
    emits: ["update:modal"],
    setup(props, { emit }) {
        const repositories = inject('repositories');
        const extrachargeCategoryRepository = repositories ? repositories.extraChargeCategory : null;

        const extrachargeCategoryForm = ref({
            name: ''
        });

        const updateModal = (value) => {
            emit("update:modal", value); // Sync modal state with parent
        }

        const handleAction =  () => {
            props.extrachargeCategoryData.uuid ? update() : create()
        }

        const create = async () => {
            await extrachargeCategoryRepository.create(extrachargeCategoryForm.value).then(() => {
                updateModal(false)
                extrachargeCategoryForm.value = {}
                emit("addOrUpdate");
            }).catch(err => {
                console.error(err)
            })
        }

        const update = async () => {
            await extrachargeCategoryRepository.update(extrachargeCategoryForm.value, props.extrachargeCategoryData.uuid).then(() => {
                updateModal(false)
                extrachargeCategoryForm.value = {}
                emit("addOrUpdate");
            }).catch(err => {
                console.error(err)
            })
        }

        watch(() => props.extrachargeCategoryData, (newData) => {
            if (newData) {
                extrachargeCategoryForm.value = { ...newData };
            }
        }, { immediate: true });

        return {
            extrachargeCategoryForm,
            updateModal,
            handleAction,
            create,
            update
        }
    }
}
</script>


